import { render, staticRenderFns } from "./mode5.vue?vue&type=template&id=53a9d848&scoped=true"
import script from "./mode5.vue?vue&type=script&lang=js"
export * from "./mode5.vue?vue&type=script&lang=js"
import style0 from "./mode5.vue?vue&type=style&index=0&id=53a9d848&prod&lang=scss&scoped=true"
import style1 from "./mode5.vue?vue&type=style&index=1&id=53a9d848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a9d848",
  null
  
)

export default component.exports